<template>
  <v-container fluid>
    <!--- This is the Default Table --->

    <v-layout v-if="!tableStyle" class="clsScroll">
      <v-flex>
        <action-dialog
          :type="dialogType"
          :title="title"
          :dialog="dialogStatus"
          @closeDialog="closeDialog"
          :loading="dialogLoading"
        >
          <v-container fluid>
            <v-layout>
              <v-flex>
                <v-card class="elevation-7">
                  <table
                    id="viewTable"
                    v-for="item in viewItems"
                    :key="item.id"
                  >
                    <tr>
                      <td class="propertyName">Merchant Code:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.merchant }}
                      </td>
                      <td class="propertyName">Branch:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.terminal }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Device Serial:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.device_serial }}
                      </td>
                      <td class="propertyName">Date:</td>
                      <td
                        :class="[
                          'text-xs-center',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ $dateFormat(item.transaction_date, "YYYY-MM-DD") }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Reload Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_count_wireless == null
                            ? "--"
                            : item.reload_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Reload Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_count_sync == null
                            ? "--"
                            : item.reload_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Reload Gross (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_gross_wireless == null
                            ? "--"
                            : $amountInPeso(item.reload_gross_wireless)
                        }}
                      </td>
                      <td class="propertyName">Reload Gross (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_gross_sync == null
                            ? "--"
                            : $amountInPeso(item.reload_gross_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Sold Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.sold_count_wireless == null
                            ? "--"
                            : item.sold_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Sold Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.sold_count_sync == null
                            ? "--"
                            : item.sold_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Sold Gross (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.sold_gross_wireless == null
                            ? "--"
                            : $amountInPeso(item.sold_gross_wireless)
                        }}
                      </td>
                      <td class="propertyName">Sold Gross (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.sold_gross_sync == null
                            ? "--"
                            : $amountInPeso(item.sold_gross_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Sold Credit Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_sold_count_wireless == null
                            ? "--"
                            : item.credit_sold_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Sold Credit Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_sold_count_sync == null
                            ? "--"
                            : item.credit_sold_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Sold Credit Gross (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_sold_gross_wireless == null
                            ? "--"
                            : $amountInPeso(item.credit_sold_gross_wireless)
                        }}
                      </td>
                      <td class="propertyName">Sold Credit Gross (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_sold_gross_sync == null
                            ? "--"
                            : $amountInPeso(item.credit_sold_gross_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Credit Redeem Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_redeem_count_wireless == null
                            ? "--"
                            : item.credit_redeem_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Credit Redeem Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_redeem_count_sync == null
                            ? "--"
                            : item.credit_redeem_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Credit Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_count_wireless == null
                            ? "--"
                            : item.credit_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Credit Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_count_sync == null
                            ? "--"
                            : item.credit_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Credit Gross (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_gross_wireless == null
                            ? "--"
                            : item.credit_gross_wireless
                        }}
                      </td>
                      <td class="propertyName">Credit Gross (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.credit_gross_sync == null
                            ? "--"
                            : item.credit_gross_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Transfer Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_count_wireless == null
                            ? "--"
                            : item.transfer_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Transfer Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_count_sync == null
                            ? "--"
                            : item.transfer_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Transfer Fee Card (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_card_wireless == null
                            ? "--"
                            : item.transfer_fee_card_wireless
                        }}
                      </td>
                      <td class="propertyName">Transfer Fee Card (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_card_sync == null
                            ? "--"
                            : item.transfer_fee_card_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Transfer Fee Cash (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_cash_wireless == null
                            ? "--"
                            : item.transfer_fee_cash_wireless
                        }}
                      </td>
                      <td class="propertyName">Transfer Fee Cash (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_cash_sync == null
                            ? "--"
                            : item.transfer_fee_cash_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Transfer Fee Gross (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_gross_wireless == null
                            ? "--"
                            : item.transfer_fee_gross_wireless
                        }}
                      </td>
                      <td class="propertyName">Transfer Fee Gross (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.transfer_fee_gross_sync == null
                            ? "--"
                            : item.transfer_fee_gross_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Amount (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.gross_revenue_wireless == null
                            ? "--"
                            : $amountInPeso(item.gross_revenue_wireless)
                        }}
                      </td>
                      <td class="propertyName">Amount (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.gross_revenue_sync == null
                            ? "--"
                            : $amountInPeso(item.gross_revenue_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Total Count (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_count_wireless +
                            item.sold_count_wireless +
                            item.credit_sold_count_wireless +
                            item.credit_redeem_count_wireless +
                            item.credit_count_wireless +
                            item.transfer_count_wireless
                        }}
                      </td>
                      <td class="propertyName">Total Count (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.reload_count_sync +
                            item.sold_count_sync +
                            item.credit_sold_count_sync +
                            item.credit_redeem_count_sync +
                            item.credit_count_sync +
                            item.transfer_count_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Validation</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.discrepancy === null
                            ? "--"
                            : $amountInPeso(item.discrepancy)
                        }}
                      </td>
                      <td class="propertyName">Cashier Name:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.shift_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.cashier_name === null ? "--" : item.cashier_name
                        }}
                      </td>
                    </tr>
                  </table>
                </v-card>
              </v-flex>
            </v-layout>
            <br />
            <br />
            <br />
            <v-layout>
              <v-flex md6>
                <h3 class="d-flex align-start">Shift Sync</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <!--generate excel report for shift sync -->
              <v-tooltip>
                <v-btn
                  fab
                  dark
                  small
                  color="amber darken-2"
                  slot="activator"
                  @click="downloadExcel_ShiftSync()"
                >
                  <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 500.000000 500.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <metadata>
                      Created by potrace 1.16, written by Peter Selinger
                      2001-2019
                    </metadata>
                    <g
                      transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
                      fill="#ffffff"
                      stroke="none"
                    >
                      <path
                        d="M3675 4960 c-376 -60 -666 -340 -730 -705 -8 -48 -15 -101 -15 -116
  l0 -29 -155 0 c-85 0 -155 -3 -155 -8 0 -4 95 -102 210 -217 l210 -210 210
  210 c116 115 210 213 210 217 0 5 -70 8 -155 8 l-155 0 0 40 c0 69 21 143 67
  239 106 220 331 361 578 361 85 0 208 -26 266 -55 l32 -17 80 81 81 80 -85 40
  c-46 23 -120 50 -163 61 -94 24 -246 33 -331 20z"
                      />
                      <path
                        d="M4337 4322 c-114 -114 -207 -211 -207 -215 0 -4 70 -7 156 -7 l157 0
  -7 -67 c-15 -145 -80 -277 -192 -388 -186 -185 -464 -237 -707 -133 l-49 21
  -75 -75 c-42 -42 -73 -80 -69 -86 11 -18 152 -80 236 -103 116 -32 306 -32
  425 0 362 97 611 393 650 774 l6 57 155 0 c85 0 154 3 154 8 0 8 -412 422
  -420 422 -3 0 -99 -93 -213 -208z"
                      />
                      <path
                        d="M480 4290 c-138 -19 -261 -103 -320 -219 -52 -103 -50 -22 -50 -1867
  0 -1071 4 -1731 10 -1763 29 -156 151 -285 307 -325 54 -14 207 -16 1356 -16
  910 0 1312 3 1349 11 161 34 297 173 328 339 6 34 10 510 10 1319 l0 1266
  -633 633 -632 632 -835 -1 c-459 -1 -860 -5 -890 -9z m2565 -1350 l110 -110
  -577 0 -578 0 0 571 0 571 468 -461 c257 -254 517 -510 577 -571z m-1467 -887
  c114 -194 209 -352 212 -352 3 0 98 158 211 352 l206 352 188 3 c148 2 186 0
  182 -10 -3 -7 -139 -220 -302 -473 -227 -351 -295 -463 -287 -475 5 -8 140
  -218 301 -467 160 -248 291 -454 291 -458 0 -3 -84 -4 -187 -3 l-187 3 -197 
  335 c-109 184 -203 343 -209 353 -10 16 -40 -30 -219 -335 l-208 -353 -187 -3
  c-102 -1 -186 0 -186 4 0 3 134 214 297 467 163 253 296 466 296 472 0 6 -131
  215 -292 465 -161 250 -295 460 -298 467 -4 11 29 13 182 11 l187 -3 206 -352z"
                      />
                    </g>
                  </svg>
                </v-btn>
                <span>Download Excel File (Shift Sync)</span>
              </v-tooltip>
            </v-layout>
            <transaction-summary-list
              :headers2="headersShiftSync"
              :items2="itemShiftSync"
              :queryParams="queryParamsShift"
            ></transaction-summary-list>
            <br />
            <br />
            <br />
            <v-layout>
              <v-flex md6>
                <h3>Shift Wireless</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <!--generate excel report for shift wireless -->
              <v-tooltip top>
                <v-btn
                  fab
                  dark
                  small
                  color="amber darken-2"
                  slot="activator"
                  @click="downloadExcel_ShiftWireless()"
                >
                  <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 500.000000 500.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <metadata>
                      Created by potrace 1.16, written by Peter Selinger
                      2001-2019
                    </metadata>
                    <g
                      transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
                      fill="#ffffff"
                      stroke="none"
                    >
                      <path
                        d="M3485 4900 c-196 -31 -395 -96 -574 -187 -97 -50 -264 -154 -275
      -171 -2 -4 39 -65 91 -135 l95 -127 47 34 c146 106 385 209 586 253 118 25
      148 28 335 28 187 0 217 -3 335 -28 201 -44 440 -147 587 -254 l47 -34 95 127
      c53 70 93 130 90 135 -12 20 -179 123 -289 177 -195 98 -386 158 -593 186
      -155 22 -422 20 -577 -4z"
                      />
                      <path
                        d="M480 4290 c-138 -19 -261 -103 -320 -219 -52 -103 -50 -22 -50 -1867
      0 -1071 4 -1731 10 -1763 29 -156 151 -285 307 -325 54 -14 207 -16 1356 -16
      910 0 1312 3 1349 11 161 34 297 173 328 339 6 34 10 510 10 1319 l0 1266
      -633 633 -632 632 -835 -1 c-459 -1 -860 -5 -890 -9z m2565 -1350 l110 -110
      -577 0 -578 0 0 571 0 571 468 -461 c257 -254 517 -510 577 -571z m-1468 -885
      c114 -195 210 -354 213 -354 3 0 98 158 211 352 l206 352 188 3 c148 2 186 0
      182 -10 -3 -7 -139 -220 -302 -473 -227 -351 -295 -463 -287 -475 5 -8 140
      -218 301 -467 160 -248 291 -454 291 -458 0 -3 -84 -4 -187 -3 l-187 3 -197
      335 c-109 184 -203 343 -209 353 -10 16 -40 -30 -219 -335 l-208 -353 -187 -3
      c-102 -1 -186 0 -186 4 0 3 134 214 297 467 163 253 296 466 296 472 0 6 -131
      215 -292 465 -161 250 -295 460 -298 467 -4 10 32 13 180 13 l185 0 209 -355z"
                      />
                      <path
                        d="M3605 4265 c-219 -35 -406 -111 -579 -237 -10 -7 172 -258 187 -258
      5 0 23 11 41 25 54 41 216 112 311 136 127 32 323 32 450 0 95 -24 257 -95
      311 -136 18 -14 37 -25 42 -25 9 0 178 219 188 243 8 23 -192 140 -319 187
      -195 71 -436 96 -632 65z"
                      />
                      <path
                        d="M3630 3614 c-71 -19 -185 -71 -206 -95 -16 -18 -7 -31 175 -275 l192
      -256 194 258 193 258 -23 18 c-36 28 -143 75 -210 93 -75 19 -241 19 -315 -1z"
                      />
                    </g>
                  </svg>
                </v-btn>
                <span>Download Excel File (Shift Wireless)</span>
              </v-tooltip>
            </v-layout>
            <transaction-summary-list
              :headers2="headersShiftSync"
              :items2="itemShiftWireL"
              :queryParams="queryParamsShift"
            ></transaction-summary-list>
          </v-container>
        </action-dialog>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="theData"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
                :style="
                  header.text == 'Time'
                    ? 'border-right: 2px solid #757575;'
                    : header.text == 'Total Count (W)'
                    ? 'border-right: 2px solid #757575;'
                    : header.text == 'Total Count (S)'
                    ? 'border-right: 2px solid #757575;'
                    : header.text == 'Reload Count (W)'
                    ? 'border-left: 2px solid #757575;'
                    : header.text == 'Reload Count (S)'
                    ? 'border-left: 2px solid #757575;'
                    : header.text == 'Cashier Name'
                    ? 'border-left: 2px solid #757575;'
                    : ''
                "
              >
                <span v-if="header.text == 'Date'" @click="sortByDate">
                  {{ header.text }}
                  <v-icon>{{
                    toggleStatus ? "arrow_downward" : "arrow_upward"
                  }}</v-icon>
                </span>
                <span v-else>{{ header.text }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td
              :class="[
                'text-xs-center',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.index + 1 }}
            </td>
            <td
              :class="[
                'text-xs-center no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              <v-tooltip top>
                <v-btn
                  icon
                  small
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  @click="
                    openDialog(props.item);
                    viewTransactionsSync(props.item.id);
                    viewTransactionsWireL(props.item.id);
                  "
                >
                  <v-icon color="blue">find_in_page</v-icon>
                </v-btn>
                <span>View</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  icon
                  small
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  v-if="
                    $moduleAccess('transaction_align_shift_report') &&
                      props.item.shift_status === 0 &&
                      props.item.shift_status !== 3
                  "
                  @click="transactionALign(props.item)"
                >
                  <v-icon color="green darken-4">swap_horiz</v-icon>
                </v-btn>
                <span>Transaction Align</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  class="ma-0 pa-0"
                  icon
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  v-if="
                    $moduleAccess('align_shift_report') &&
                      props.item.shift_status !== 0 &&
                      props.item.shift_status !== 3
                  "
                  @click="syncToWireless(props.item)"
                >
                  <v-icon color="teal">swap_horiz</v-icon>
                </v-btn>
                <span>Align</span>
              </v-tooltip>
            </td>
            <td
              :class="[
                'text-xs-left text-uppercase',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.merchant }}
            </td>
            <td
              :class="[
                'text-xs-left',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.device_serial }}
            </td>
            <td
              :class="[
                'text-xs-left text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.terminal }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.opening_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.opening_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.closing_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.closing_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.date_validation === null
                  ? "--"
                  : props.item.date_validation
              }}
            </td>

            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.reload_count_wireless == null
                  ? "--"
                  : props.item.reload_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.reload_gross_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.reload_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.sold_count_wireless == null
                  ? "--"
                  : props.item.sold_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.sold_gross_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.sold_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_sold_count_wireless == null
                  ? "--"
                  : props.item.credit_sold_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_sold_gross_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.credit_sold_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_redeem_count_wireless == null
                  ? "--"
                  : props.item.credit_redeem_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_count_wireless == null
                  ? "--"
                  : props.item.credit_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_gross_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.credit_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_count_wireless == null
                  ? "--"
                  : props.item.transfer_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_card_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_card_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_cash_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_cash_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_gross_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.gross_revenue_wireless == null
                  ? "--"
                  : $amountInPeso(props.item.gross_revenue_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.reload_count_wireless +
                  props.item.sold_count_wireless +
                  props.item.credit_sold_count_wireless +
                  props.item.credit_redeem_count_wireless +
                  props.item.credit_count_wireless +
                  props.item.transfer_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.reload_count_sync == null
                  ? "--"
                  : props.item.reload_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.reload_gross_sync == null
                  ? "--"
                  : $amountInPeso(props.item.reload_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.sold_count_sync == null
                  ? "--"
                  : props.item.sold_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.sold_gross_sync == null
                  ? "--"
                  : $amountInPeso(props.item.sold_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_sold_count_sync == null
                  ? "--"
                  : props.item.credit_sold_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_sold_gross_sync == null
                  ? "--"
                  : $amountInPeso(props.item.credit_sold_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_redeem_count_sync == null
                  ? "--"
                  : props.item.credit_redeem_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_count_sync == null
                  ? "--"
                  : props.item.credit_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.credit_gross_sync == null
                  ? "--"
                  : $amountInPeso(props.item.credit_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_count_sync == null
                  ? "--"
                  : props.item.transfer_count_sync
              }}
            </td>

            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_card_sync == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_card_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_cash_sync == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_cash_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.transfer_fee_gross_sync == null
                  ? "--"
                  : $amountInPeso(props.item.transfer_fee_gross_sync)
              }}
            </td>
                
             <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.lost_transaction_count === null
                  ? "--"
                  : props.item.lost_transaction_count
              }}
            </td>

             <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.lost_transaction_total === null
                  ? "--"
                  : $amountInPeso(props.item.lost_transaction_total)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.gross_revenue_sync == null
                  ? "--"
                  : $amountInPeso(+props.item.lost_transaction_total + props.item.gross_revenue_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                +props.item.lost_transaction_count +
                props.item.reload_count_sync +
                  props.item.sold_count_sync +
                  props.item.credit_sold_count_sync +
                  props.item.credit_redeem_count_sync +
                  props.item.credit_count_sync +
                  props.item.transfer_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.discrepancy == null
                  ? "--"
                  : $amountInPeso(props.item.discrepancy)
              }}
            </td>
            <td
              :class="[
                'text-xs-left no-wrap',
                props.item.shift_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.cashier_name == null ? "--" : props.item.cashier_name
              }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- This is the Grid Style Table -->

    <shift-reports-native
      v-if="tableStyle"
      :items="theData"
      :toggStatus="toggleStatus"
      style="padding: 0px;"
      @toggleDate="sortByDate"
      @sync="syncToWireless"
    ></shift-reports-native>
  </v-container>
</template>

<script>
import ShiftReportsNative from "@/components/tripko/ExceptionReports/ShiftReportsNative";
import Services from "@/services/Services";
import TransactionSummaryList from "@/components/tripko/TransactionTable/TransactionSummaryList.vue";
import XLSX from "xlsx";

var now = new Date();

export default {
  components: {
    ShiftReportsNative,
    TransactionSummaryList,
  },
  props: {
    items: Array,
    tableStyle: Boolean,
    headers: Array,
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      queryParams: {
        search: "",
        transaction_id: null,
        type: null,
      },
      queryParamsShift: {
        search: null,
        offset: 0,
        limit: 200,
      },
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      toggleStatus: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      itemShiftSync: [],
      itemShiftWireL: [],
      headersShiftSync: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Trx No.",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "center",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "type",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "right",
          value: "remaining_balance",
          sortable: false,
        },
        {
          text: "Card Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    theData() {
      let theData = [];
      let aNewArray = [];

      this.items.forEach((item) => {
        aNewArray.push(item);
      });

      if (this.toggleStatus == true) {
        let dateASC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.opening_shift_datetime),
            dateB = new Date(b.opening_shift_datetime);
          return dateA - dateB;
        });

        dateASC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else if (this.toggleStatus == false) {
        let dateDESC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.opening_shift_datetime),
            dateB = new Date(b.opening_shift_datetime);
          return dateB - dateA;
        });

        dateDESC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else {
        return this.items;
      }
    },
  },
  methods: {
    async viewTransactionsSync(data) {
      let dataViewSync = (await Services.getShiftSyncView(data)).data;
      this.itemShiftSync = dataViewSync.data;
    },
    async viewTransactionsWireL(data) {
      let dataViewWireless = (await Services.getShiftWirelessView(data)).data;
      this.itemShiftWireL = dataViewWireless.data;
    },
    async downloadExcel_ShiftSync() {
      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headersShiftSync.length; i++) {
        header.push(this.headersShiftSync[i].text);
      }

      header.splice(0, 1);

      dataToDownload.push(header);

      for (let e = 0; e < this.itemShiftSync.length; e++) {
        let theItem = [];

        theItem.push(this.itemShiftSync[e].transaction_no),
          theItem.push(this.itemShiftSync[e].card_no),
          theItem.push(
            this.$dateFormat(this.itemShiftSync[e].transaction_date, "HH:mm"),
          ),
          theItem.push(
            this.itemShiftSync[e].transaction_type.name.toUpperCase(),
          ),
          theItem.push(this.itemShiftSync[e].remaining_balance.toFixed(2)),
          theItem.push(this.itemShiftSync[e].card_amount.toFixed(2));

        dataToDownload.push(theItem);
      }

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async downloadExcel_ShiftWireless() {
      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headersShiftSync.length; i++) {
        header.push(this.headersShiftSync[i].text);
      }

      header.splice(0, 1);

      dataToDownload.push(header);

      for (let e = 0; e < this.itemShiftWireL.length; e++) {
        let theItem = [];

        theItem.push(this.itemShiftWireL[e].transaction_no),
          theItem.push(this.itemShiftWireL[e].card_no),
          theItem.push(
            this.$dateFormat(this.itemShiftWireL[e].transaction_date, "HH:mm"),
          ),
          theItem.push(
            this.itemShiftWireL[e].transaction_type.name.toUpperCase(),
          ),
          theItem.push(this.itemShiftWireL[e].remaining_balance.toFixed(2)),
          theItem.push(this.itemShiftWireL[e].card_amount.toFixed(2));

        dataToDownload.push(theItem);
      }

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    sortByDate() {
      this.toggleStatus = !this.toggleStatus;
    },
    syncToWireless(data) {
      this.$emit("sync", data);
    },
    transactionALign(data) {
      this.$emit("transactionALign", data);
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.theError {
  color: red;
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
